import { CONTENT_TYPES } from './index'
import DebtConsolidationStatesCitiesRepository from '../../repositories/DebtConsolidationStatesCitiesRepository'

export const contentTypeToRepositoryMap = {
  [CONTENT_TYPES.DEBT_CONSOLIDATION_STATES_CITIES]: {
    getInstance: () => DebtConsolidationStatesCitiesRepository.getInstance(),
    methodName: 'fillCities',
  },
}

export const ldVariationEnums = {
  control: {
    name: 'Control',
    label: 'control',
  },
  'variation-a': {
    name: 'Variation A',
    label: 'variation_a',
  },
  'variation-b': {
    name: 'Variation B',
    label: 'variation_b',
  },
}

export const commonSchemaData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://www.freedomdebtrelief.com/#organization',
  logo: 'https://www.freedomdebtrelief.com/next-assets/fdr-logo.webp',
  legalName: 'Freedom Debt Relief, LLC',
  name: 'Freedom Debt Relief, LLC',
  url: 'https://www.freedomdebtrelief.com/facts/',
  description:
    'Freedom Debt Relief, LLC is the largest debt settlement company in the United States, specializing in helping consumers resolve unsecured debt, particularly credit card debt.',
  sameAs: [
    'https://www.linkedin.com/company/freedom-debt-relief/',
    'https://www.crunchbase.com/organization/freedom-debt-relief-3bd9',
    'https://www.dnb.com/business-directory/company-profiles.freedom_debt_relief_llc.166a0dadaba157f009a4744c0bd8c1d7.html',
    'https://www.wikidata.org/wiki/Q133894770',
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1875 S Grant St Ste 300',
    addressLocality: 'San Mateo',
    addressRegion: 'CA',
    postalCode: '94402',
    addressCountry: 'US',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    type: 'ContactPoint',
    telephone: '+18002301553',
    contactType: 'business office',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.6',
    ratingCount: '46402',
    reviewCount: '46402',
  },
}

export const localBusinessSchemaData = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Freedom Debt Relief',
  url: 'https://www.freedomdebtrelief.com',
  logo: 'https://www.freedomdebtrelief.com/next-assets/fdr-logo.webp',
  hasMap: 'https://www.google.com/maps?cid=1138888979161863326',

  description:
    'Freedom Debt Relief helps clients lower their monthly debt payments without bankruptcy or loans.',

  address: {
    '@type': 'PostalAddress',
    streetAddress: '1875 S Grant St Ste 300',
    addressLocality: 'San Mateo',
    addressRegion: 'CA',
    postalCode: '94402',
    addressCountry: 'US',
  },

  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+1-800-655-6303',
    contactType: 'customer service',
  },

  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.6',
    reviewCount: '46402',
  },

  potentialAction: {
    '@type': 'WriteAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://www.freedomdebtrelief.com/reviews/write',
      inLanguage: 'en',
      actionPlatform: [
        'http://schema.org/DesktopWebPlatform',
        'http://schema.org/MobileWebPlatform',
      ],
    },
  },
  parentOrganization: {
    '@type': 'Organization',
    name: 'Freedom Debt Relief, LLC',
    legalName: 'Freedom Debt Relief, LLC',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.freedomdebtrelief.com/next-assets/fdr-logo.webp',
    },
    sameAs: [
      'https://www.linkedin.com/company/freedom-debt-relief/',
      'https://www.crunchbase.com/organization/freedom-debt-relief-3bd9',
      'https://www.dnb.com/business-directory/company-profiles.freedom_debt_relief_llc.166a0dadaba157f009a4744c0bd8c1d7.html',
      'https://www.wikidata.org/wiki/Q133894770',
    ],
  },
}

export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.freedomdebtrelief.com/',
  name: 'Freedom Debt Relief',
  publisher: {
    '@type': 'Organization',
    logo: 'https://www.freedomdebtrelief.com/next-assets/fdr-logo.webp',
    legalName: 'Freedom Debt Relief, LLC',
    name: 'Freedom Debt Relief, LLC',
    sameAs: [
      'https://www.linkedin.com/company/freedom-debt-relief/',
      'https://www.crunchbase.com/organization/freedom-debt-relief-3bd9',
      'https://www.dnb.com/business-directory/company-profiles.freedom_debt_relief_llc.166a0dadaba157f009a4744c0bd8c1d7.html',
      'https://www.wikidata.org/wiki/Q133894770',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '1875 S Grant St Ste 300',
      addressLocality: 'San Mateo',
      addressRegion: 'CA',
      postalCode: '94402',
      addressCountry: {
        '@type': 'Country',
        name: 'US',
      },
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+18009100065',
      contactType: 'business office',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.6',
      ratingCount: '46402',
      reviewCount: '46402',
    },
  },
}

export const getTrustPilotInfo = (trustMarkersResponse, trustMarker) => {
  const trustMarkerInfo = trustMarkersResponse.find(
    (item) => item.id.toLowerCase() === 'home-variant-8'
  )
  const trustPilot = trustMarkerInfo?.trustMarker.find(
    (item) => item?.fields?.id?.toLowerCase() === 'truspilot'
  )
  if (trustPilot) {
    trustMarker = {
      ratingValue: Number(trustPilot?.fields?.rating),
      ratingCount: Number(trustPilot?.fields?.totalReview),
      reviewCount: Number(trustPilot?.fields?.totalReview),
    }
  }

  return trustMarker
}
